import { render, staticRenderFns } from "./CaseTimeline.vue?vue&type=template&id=239e943d&scoped=true"
import script from "./CaseTimeline.vue?vue&type=script&lang=ts"
export * from "./CaseTimeline.vue?vue&type=script&lang=ts"
import style0 from "./CaseTimeline.vue?vue&type=style&index=0&id=239e943d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239e943d",
  null
  
)

export default component.exports